import { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Grid,
  IconButton,
  TextField,
  Typography,
} from '@material-ui/core';
import { Add as AddIcon, Remove as RemoveIcon } from '@material-ui/icons';

function KeyValueControl(props = KeyValueControl.defaultProps) {
  const {
    events = {},
    label,
    name: controlName,
    value,
    onChange,
    settings: userSettings = {},
  } = props;

  const settings = {
    keyLabel: userSettings.keyLabel || KeyValueControl.defaultProps.settings.keyLabel,
    valueLabel: userSettings.valueLabel || KeyValueControl.defaultProps.settings.valueLabel,
    keyBreakpoints: {
      ...KeyValueControl.defaultProps.settings.keyBreakpoints,
      ...(userSettings.keyBreakpoints || {}),
    },
    valueBreakpoints: {
      ...KeyValueControl.defaultProps.settings.valueBreakpoints,
      ...(userSettings.valueBreakpoints || {}),
    },
    spacing: userSettings.spacing || KeyValueControl.defaultProps.settings.spacing,
  };
  const [items, setItems] = useState([
    ...Object.entries(value || []),
    ['', ''],
  ]);

  const handleAdd = () => {
    const tmpItems = items;
    const index = tmpItems.length - 1;
    const [key, val] = tmpItems[index];

    if (key && val) {
      const newItems = [...tmpItems, ['', '']];
      setItems(newItems);
      // Disparar onChange para sincronizar con Formik
      const target = {
        name: controlName,
        value: Object.fromEntries(newItems.filter(([k, v]) => k !== '')),
      };
      onChange({
        target,
      });
      if (events.onChange) {
        events.onChange(target);
      }
    }
  };

  const handleDelete = (index) => {
    const newItems = items.filter((_, i) => i !== index);
    setItems(newItems);
    // Disparar onChange para sincronizar con Formik
    const target = {
      name: controlName,
      value: Object.fromEntries(newItems.filter(([k, v]) => k !== '')),
    };
    onChange({
      target,
    });
    if (events.onChange) {
      events.onChange(target);
    }
  };

  const handleBlur = ({ target: { name, value } }) => {
    // onBlur();
  };

  const handleChange = ({ target: { name, value } }) => {
    const tmpItems = items;
    const [elem, index] = name.split('_');
    tmpItems[index][elem === 'key' ? 0 : 1] = value;

    setItems(tmpItems);

    const target = {
      name: controlName,
      value: Object.fromEntries(tmpItems),
    };
    onChange({
      target,
    });

    if (events.onChange) {
      events.onChange(target);
    }
  };

  return (
    <fieldset
      style={{
        borderRadius: 5,
      }}
    >
      <legend
        style={{
          marginLeft: 8,
        }}
      >
        <Typography color="textSecondary" variant="caption">
          <Box
            style={{
              marginLeft: 5,
              marginRight: 5,
            }}
          >
            {label}
          </Box>
        </Typography>
      </legend>
      <Box m={1}>
        {items.map(([key, val], index) => (
          <Grid container key={index} spacing={settings.spacing}>
            <Grid item md={settings.keyBreakpoints.md} sm={settings.keyBreakpoints.sm} xs={settings.keyBreakpoints.xs}>
              <TextField
                name={`key_${index}`}
                value={key}
                fullWidth={true}
                label={settings.keyLabel}
                size="small"
                variant="outlined"
                onBlur={handleBlur}
                onChange={handleChange}
              />
            </Grid>
            <Grid item md={settings.valueBreakpoints.md} sm={settings.valueBreakpoints.sm} xs={settings.valueBreakpoints.xs}>
              <TextField
                name={`value_${index}`}
                value={val}
                fullWidth={true}
                label={settings.valueLabel}
                size="small"
                variant="outlined"
                onBlur={handleBlur}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={1}>
              <IconButton
                children={
                  items.length === index + 1 ? <AddIcon /> : <RemoveIcon />
                }
                color={items.length === index + 1 ? 'primary' : 'error'}
                size="small"
                onClick={() => {
                  if (items.length === index + 1) {
                    handleAdd();
                  } else {
                    handleDelete(index);
                  }
                }}
              />
            </Grid>
          </Grid>
        ))}
      </Box>
    </fieldset>
  );
}

KeyValueControl.defaultProps = {
  value: {},
  onChange: () => {},
  onBlur: () => {},
  settings: {
    keyLabel: 'Llave',
    valueLabel: 'Valor',
    keyBreakpoints: {
      md: 5,
      sm: 5,
      xs: 4,
    },
    valueBreakpoints: {
      md: 6,
      sm: 6,
      xs: 6,
    },
    spacing: 2,
  },
};

KeyValueControl.propTypes = {
  events: PropTypes.shape({
    onChange: PropTypes.func,
  }),
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.object,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  settings: PropTypes.shape({
    keyLabel: PropTypes.string,
    valueLabel: PropTypes.string,
    keyBreakpoints: PropTypes.shape({
      md: PropTypes.number,
      sm: PropTypes.number,
      xs: PropTypes.number,
    }),
    valueBreakpoints: PropTypes.shape({
      md: PropTypes.number,
      sm: PropTypes.number,
      xs: PropTypes.number,
    }),
    spacing: PropTypes.number,
  }),
};

export default KeyValueControl;
